<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <label>Paciente</label>
                  <v-select
                    :options="pacientes"
                    :label="'nome'"
                    v-model="paciente_selecionado"
                    @input="selectPaciente"
                  ></v-select>
                </div>
                <div class="col-md-4">
                  <label>Nome da Mãe</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="receita.nome_mae"
                    disabled
                  />
                </div>
                <div class="col-md-2">
                  <label>CPF</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="receita.cpf"
                    v-mask="'999.999.999-99'"
                    disabled
                  />
                </div>
                <div class="col-md-2">
                  <label>Cartão SUS</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="receita.cartao_sus"
                    disabled
                  />
                </div>
                <div class="col-md-2">
                  <label>Ano</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="receita.ano"
                  />
                </div>
                <div class="col-md-2">
                  <label>Data da emissão</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="receita.data_emissao"
                  />
                </div>
                <div class="col-md-2">
                  <label>Cidade</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="receita.cidade"
                  />
                </div>
                <div class="col-md-2">
                  <label>Inscrição</label>
                  <v-select
                    :options="profissionais"
                    :searchble="true"
                    :label="'numero_conselho'"
                    v-model="crm_medico"
                    @input="selectMedico"
                  ></v-select>
                </div>
                <div class="col-md-4">
                  <label>Profissional</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="nome_profissional"
                    disabled
                  />
                </div>

                <div class="col-md-3">
                  <label>Grupo</label>
                  <v-select
                    :options="grupos"
                    :reduce="(grupos) => grupos.id"
                    :label="'nome'"
                    v-model="receita.grupo_id"
                  ></v-select>
                </div>
                <div class="col-md-3">
                  <label>Material</label>
                  <v-select
                    :options="materiais"
                    :reduce="(materiais) => materiais.id"
                    :label="'nome'"
                    v-model="receita.material_id"
                  ></v-select>
                </div>
                <div class="col-md-1">
                  <label>Quantidade</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="receita.quantidade"
                  />
                </div>
                <div class="col-md-2">
                  <label>Tempo de tratamento</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="receita.tempo_tratamento"
                  />
                </div>
                <div class="col-md-12 text-right">
                  <hr />
                  <router-link to="/receitas" class="btn btn-back mr-1">
                    <i class="fa fa-arrow-left" />
                    Voltar
                  </router-link>
                  <a class="btn btn-add" @click="save">
                    Salvar
                    <i class="fa fa-save" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      receita: {},
      paciente_selecionado: {},
      crm_medico: {},
      nome_profissional: "",
      pacientes: [],
      grupos: [],
      profissionais: [],
      materiais: [],
    };
  },
  computed: {},
  methods: {
    selectPaciente() {
      this.receita.nome_mae = this.paciente_selecionado.nome_mae;
      this.receita.cartao_sus = this.paciente_selecionado.cartao_sus;
      this.receita.cpf = this.paciente_selecionado.cpf;
      this.receita.paciente_id = this.paciente_selecionado.id;
    },
    selectMedico() {
      this.receita.inscricao = this.crm_medico.numero_conselho;
      this.nome_profissional = this.crm_medico.nome;
      this.receita.profissional_id = this.crm_medico.id;
    },

    save: function () {
      const self = this;
      let api = self.$store.state.api + "receitas";

      self.$loading(true);

      if (self.receita.id) {
        self.receita._method = "PUT";
        api += "/" + self.receita.id;
      }

      axios
        .post(api, self.receita)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.$loading(false);
          this.$router.push("/receitas");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },

    getReceita: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "receitas/" +
        id +
        "?with[]=paciente" +
        "&with[]=profissional";

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.receita = response.data.data[0];
          self.paciente_selecionado = self.receita.paciente.nome;
          self.crm_medico = self.receita.inscricao;
          self.nome_profissional = self.receita.profissional.nome;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getMateriais: function () {
      const self = this;
      const api = self.$store.state.api + "materiais?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.materiais = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getProfissionais: function () {
      const self = this;
      const api = self.$store.state.api + "profissionais?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.profissionais = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getGrupos: function () {
      const self = this;
      const api = self.$store.state.api + "grupos?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.grupos = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getPacientes: function () {
      const self = this;
      const api = self.$store.state.api + "pacientes?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.pacientes = response.data.data;
          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
  },

  mounted: function () {
    const self = this;
    self.getMateriais();
    self.getProfissionais();
    self.getGrupos();
    self.getPacientes();

    let id = self.$route.params.id;
    if (id) {
      self.getReceita(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>